import React from 'react';
import { ChevronLeft, Shield, CheckCircle2, Copy, Lock } from 'lucide-react';
interface ScreenProps {
  onNavigate: (screenId: number) => void;
}
export function Screen9({
  onNavigate
}: ScreenProps) {
  return <div className="min-h-full bg-datmont-900 flex flex-col pb-10 relative overflow-hidden" data-id="element-397">
      {/* Header */}
      <div className="px-4 py-4 flex items-center relative z-10" data-id="element-398">
        <button onClick={() => onNavigate(3)} className="p-2 -ml-2 text-white/70 hover:text-white hover:bg-white/10 rounded-full transition-colors" data-id="element-399">
          <ChevronLeft className="w-6 h-6" data-id="element-400" />
        </button>
        <h1 className="text-base font-bold text-white ml-2" data-id="element-401">
          Datmont Digital Apostille
        </h1>
      </div>

      <div className="flex-1 px-6 py-8 flex flex-col items-center relative z-10" data-id="element-402">
        {/* Glowing Seal Graphic */}
        <div className="relative w-48 h-48 mb-8 flex items-center justify-center" data-id="element-403">
          <div className="absolute inset-0 bg-datmont-blue/20 rounded-full blur-2xl animate-pulse" data-id="element-404"></div>
          <div className="absolute inset-4 border border-datmont-blue/30 rounded-full animate-[spin_10s_linear_infinite]" data-id="element-405"></div>
          <div className="absolute inset-8 border border-datmont-blue/50 rounded-full border-dashed animate-[spin_15s_linear_infinite_reverse]" data-id="element-406"></div>

          <div className="w-32 h-32 bg-gradient-to-br from-datmont-800 to-datmont-900 rounded-full border-2 border-datmont-blue flex flex-col items-center justify-center shadow-[0_0_30px_rgba(0,85,255,0.4)] relative z-10" data-id="element-407">
            <Shield className="w-10 h-10 text-datmont-blue mb-1" data-id="element-408" />
            <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full animate-[spin_20s_linear_infinite]" data-id="element-409">
              <path id="curve" d="M 50 15 A 35 35 0 1 1 49.9 15" fill="transparent" data-id="element-410" />
              <text className="text-[10px] font-bold fill-datmont-blue tracking-[0.2em] uppercase" data-id="element-411">
                <textPath href="#curve" startOffset="50%" textAnchor="middle" data-id="element-412">
                  Datmont • Digital • Apostille •
                </textPath>
              </text>
            </svg>
          </div>
        </div>

        <p className="text-center text-sm text-white/90 leading-relaxed mb-10 max-w-[240px]" data-id="element-413">
          This document is sealed with a <br data-id="element-414" />
          <span className="font-bold text-white" data-id="element-415">
            Datmont Digital Apostille.
          </span>
        </p>

        {/* Details Card */}
        <div className="w-full bg-white rounded-2xl p-5 space-y-5 shadow-xl" data-id="element-416">
          <div className="flex items-center justify-between border-b border-slate-100 pb-4" data-id="element-417">
            <div data-id="element-418">
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-419">
                Issuer Signature
              </p>
              <p className="text-sm font-bold text-datmont-900" data-id="element-420">
                FBI – Verified
              </p>
            </div>
            <div className="w-6 h-6 rounded-full bg-datmont-blue flex items-center justify-center" data-id="element-421">
              <CheckCircle2 className="w-4 h-4 text-white" data-id="element-422" />
            </div>
          </div>

          <div className="border-b border-slate-100 pb-4" data-id="element-423">
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-424">
              Timestamp
            </p>
            <p className="text-sm font-medium text-datmont-900" data-id="element-425">
              Mar 12, 2024{' '}
              <span className="text-slate-500 ml-1" data-id="element-426">09:14 AM UTC</span>
            </p>
          </div>

          <div className="flex items-center justify-between" data-id="element-427">
            <div data-id="element-428">
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-429">
                Verification Hash
              </p>
              <p className="text-xs font-mono font-medium text-slate-600" data-id="element-430">
                9F3A 7C21 4B98 D2E1 6F44...
              </p>
            </div>
            <button className="p-2 text-slate-400 hover:text-datmont-blue hover:bg-blue-50 rounded-lg transition-colors" data-id="element-431">
              <Copy className="w-4 h-4" data-id="element-432" />
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 pb-6 relative z-10" data-id="element-433">
        <div className="flex items-center justify-center gap-2 text-white/50" data-id="element-434">
          <Lock className="w-3 h-3" data-id="element-435" />
          <span className="text-[10px] font-medium uppercase tracking-widest" data-id="element-436">
            Tamper-Proof • Cryptographically Signed
          </span>
        </div>
        <p className="text-center text-[10px] text-white/30 mt-1" data-id="element-437">
          Instantly Verifiable
        </p>
      </div>
    </div>;
}